export default __webpack_public_path__ + "static/media/11.f9bb2e04.png";